import { useDisclosure } from '@chakra-ui/react';
import { MdAccountTree } from 'react-icons/md';
import { MButton } from '../../../../../components/Monetize';
import { getQuoteOfferingGroupPermissions } from '../../../../../utils/quotes';
import { useQuoteContext } from '../../quoteContext';
import { getManageGroupsTitle } from './manageQuoteOfferingGroupsConstants';
import { ManageQuoteOfferingGroupsModal } from './ManageQuoteOfferingGroupsModal';

/**
 * Entry point for the bulk group workbench. Keeps the modal (and the per-row
 * account/contact queries it mounts) out of the page until it is opened, and
 * keeps the host table's involvement to a single element.
 */
export const ManageQuoteOfferingGroupsLauncher = () => {
  const { open: isOpen, onOpen, onClose } = useDisclosure();
  const {
    quoteData: { quote },
    isReadOnly,
  } = useQuoteContext();

  return (
    <>
      <MButton
        variant="tertiary"
        size="sm"
        leftIcon={<MdAccountTree />}
        onClick={onOpen}
        data-testid="manage-quote-offering-groups-btn"
      >
        {getManageGroupsTitle(
          getQuoteOfferingGroupPermissions({ quote, isReadOnly }).isReadOnly,
        )}
      </MButton>
      {isOpen && (
        <ManageQuoteOfferingGroupsModal isOpen={isOpen} onClose={onClose} />
      )}
    </>
  );
};
